import { buildAccessFlags } from '@/utils/admin-auth';

export default function access(
  initialState:
    | {
        currentUser?: {
          primary_role?: string;
          account_status?: string;
          permissions?: string[];
        };
      }
    | undefined,
) {
  const { currentUser } = initialState ?? {};
  return buildAccessFlags(currentUser);
}
